/* eslint camelcase: 0 */
import { MonitaroGatewayBase } from './base'
import { toMessageProps, toMessageRequest } from './translator/message'
import { toQuery, toQueryProps } from './translator/query'
import { EmptyResponsePropsFactory } from '@/entities/Response'
import { IQueryProps } from '@/entities/Query'
import { FetchMessage, PostMessage, GetMessage, PutMessage, DeleteMessage, PutSendMessage } from '@/infrastructure/network/Monitaro/requests/message'
import { IMessageProps } from '@/entities/Message'

export default class Message extends MonitaroGatewayBase {
  async FetchMessage(query?: IQueryProps) {
    const response = await this.apiClient.request(new FetchMessage(toQuery(query)))
    return EmptyResponsePropsFactory({
      items: response.messages.map((prop) => toMessageProps(prop)),
      query: toQueryProps(response.query)
    })
  }

  async PostMessage(params: IMessageProps) {
    const { message } = await this.apiClient.request(new PostMessage(toMessageRequest(params)))
    return toMessageProps(message)
  }

  async GetMessage(id: string) {
    const { message } = await this.apiClient.request(new GetMessage(id))
    return toMessageProps(message)
  }

  async PutMessage(id: string, params: IMessageProps) {
    const { message } = await this.apiClient.request(new PutMessage(id, toMessageRequest(params)))
    return toMessageProps(message)
  }

  async DeleteMessage(id: string) {
    const { message } = await this.apiClient.request(new DeleteMessage(id))
    return toMessageProps(message)
  }

  async PutSendMessage(id: string, params: IMessageProps) {
    const { message } = await this.apiClient.request(new PutSendMessage(id, toMessageRequest(params)))
    return toMessageProps(message)
  }
}
